
  const role = {
    path: "/role",
    name: "role",
    component: () => import(/* webpackChunkName: "role" */ "@/components/role/RoleIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "role" */ "@/components/role/RoleView.vue"), name: "roleView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "role" */ "@/components/role/RoleEdit.vue"), name: "roleEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "role" */ "@/components/role/RoleCreate.vue"), name: "roleCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default role;
    